'use client';

import { DEFAULT_QUALIFICATION_OPTIONS as SHARED_DEFAULT_QUALIFICATION_OPTIONS } from '../../react/InlineForm';
import type { InlineFormProps } from '../../react/InlineForm';
import { InlineForm as SharedInlineForm } from '../../react/InlineForm';
import { GETAPP_BRAND_CONFIG as GETAPP_BRAND_CONFIG_INTERNAL } from '../../react/brandConfig';

export type {
  InlineFormProps,
  InlineFormTemplate,
} from '../../react/InlineForm';
export const DEFAULT_QUALIFICATION_OPTIONS =
  SHARED_DEFAULT_QUALIFICATION_OPTIONS;
export const GETAPP_BRAND_CONFIG = GETAPP_BRAND_CONFIG_INTERNAL;

const GetAppInlineForm = (props: InlineFormProps) => (
  <SharedInlineForm
    cardBackground="brand"
    {...props}
    brandConfig={GETAPP_BRAND_CONFIG}
  />
);

GetAppInlineForm.displayName = 'GetAppInlineForm';

export const InlineForm = GetAppInlineForm;

/** @deprecated Use InlineForm instead */
export const MinimalInlineForm = InlineForm;
/** @deprecated Use InlineFormProps instead */
export type MinimalInlineFormProps = InlineFormProps;
/** @deprecated Use InlineFormTemplate instead */
export type InlineFormVariant = 'minimal' | 'card-dark';
